export default __webpack_public_path__ + "static/media/demo3.e0d2951b.png";